/* eslint-disable no-prototype-builtins */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
import React from 'react';
import storage from '@xto10x/storage/lib';
import getCookie from '@xto10x/oauth2/lib/getCookie';
import { dim } from 'styles/theme';
import {
  getValueFromQueryParam,
  isNotEmptyString,
  capitalizeString,
  convertTimeToString
} from '@xto10x/core/lib/app.utils';
import { format_date } from '@xto10x/core/lib/moment.util';
import { getLastDayOfTheMonth } from 'utils/moment.util';
import shortid from 'shortid';
import analytics from '@xto10x/core/lib/analytics';
import configApi from 'services/configApi';
import parse from 'date-fns/parse';
import isValid from 'date-fns/isValid';
import config from 'utils/config';

import {
  StorageKey,
  HeaderLeftTabs,
  EMOJIS_PALETTE_OPTIONS,
  APPLICATION_CHANNELS,
  IntegrationChannelLabelMap,
  QueryParam,
  ObjectiveStatusTypes,
  ObjectiveNegotiationStates,
  UserRole,
  ObjectiveCycleTypes,
  ObjectiveStatus,
  ManagerApprovalStatus,
  UserViews,
  UserSubscriptionTypes,
  CuesHeaderInvisibilityPaths,
  ConfigCacheKeys,
  OBJECTIVE_VISIBILITY_TYPES,
  OwnerAssignmentErrors,
  DateConversionType,
  FirebaseKeys
} from './constants';

const appUtils = {
  getSelectedTeam: (teams = [], selectedTeamId) => {
    if (selectedTeamId) {
      if (selectedTeamId === HeaderLeftTabs[1].tag_id) {
        return HeaderLeftTabs[1];
      }
      if (selectedTeamId === HeaderLeftTabs[2].tag_id) {
        return HeaderLeftTabs[2];
      }
      for (let i = 0; i <= teams.length; i += 1) {
        if (teams[i] && selectedTeamId === teams[i].tag_id) {
          return teams[i];
        }
      }
    }
    return HeaderLeftTabs[0];
  },

  isHeaderLeftTabs: tag_id =>
    tag_id == null ||
    tag_id === HeaderLeftTabs[0].tag_id ||
    tag_id === HeaderLeftTabs[1].tag_id ||
    tag_id === HeaderLeftTabs[2].tag_id,

  adjustInputHeight: (elementID, resetHeight, defaultHeight) => {
    const elem = document.getElementById(elementID);
    if (elem) {
      if (resetHeight) {
        elem.setAttribute('style', `height: ${defaultHeight || dim._50px}`);
        return;
      }
      elem.setAttribute('style', `height: ${defaultHeight || dim._50px}`);
      elem.setAttribute('style', `height: ${elem.scrollHeight}px`);
    }
  },

  /* Remove all the emojis supported in emoji palette from a string */
  removeEmojisFromAString: text => {
    if (!text) return text;
    Object.keys(EMOJIS_PALETTE_OPTIONS.emojis_data).forEach(emoji => {
      if (text) text = text.replace(new RegExp(emoji, 'g'), '');
    });
    if (text) text = text.trim();
    return text;
  },
  getFullMonth: index =>
    [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ][index],
  parseAlertTextMessage: text => {
    /* currently adding support for badges */
    if (!text) return text;
    const result = [];
    const badgeRegex = new RegExp(/\$badge[a-zA-Z0-9]\$badge/, 'ig');
    let matches = text.match(badgeRegex);
    matches = matches.map(match => match.split('$badge')[1]);
    const splittedText = text.split(badgeRegex);
    let i = 0;
    let j = 0;
    for (; i < splittedText.length - 1; i++) {
      result.push(splittedText[i]);
      result.push(<span className="badgeHighlightsBlue">{matches[j]}</span>);
      j += 1;
    }
    result.push(splittedText[i]);
    return result;
  },
  parseLevelsData: (currentUser, levels) => {
    if (levels?.length > 0) {
      return levels
        .filter(
          level =>
            level.enabled &&
            (!level.orgs ||
              level.orgs.length === 0 ||
              level.orgs.includes(
                currentUser?.org_reference_id ||
                  storage.getDataFromLocal(StorageKey.ORG_INFO)
                    ?.org_reference_id
              )) &&
            (!level.excludeOrgs ||
              level.excludeOrgs.length === 0 ||
              !level.excludeOrgs.includes(
                currentUser?.org_reference_id ||
                  storage.getDataFromLocal(StorageKey.ORG_INFO)
                    ?.org_reference_id
              ))
        )
        .map(level => level.value);
    }
    return levels;
  },
  parseFilterCategoriesData: filters => {
    if (filters?.length > 0) {
      return filters.filter(
        f =>
          f.enable &&
          (!f.orgs ||
            f.orgs.length === 0 ||
            f.orgs.includes(
              storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id
            )) &&
          (!f.excludeOrgs ||
            f.excludeOrgs.length === 0 ||
            !f.excludeOrgs.includes(
              storage.getDataFromLocal(StorageKey.ORG_INFO)?.org_reference_id
            ))
      );
    }
    return filters;
  },
  generateComponentId: (id, text, component) => {
    let innerText = text;
    const componentName = component;
    innerText += componentName;
    return (
      id ||
      `${
        innerText
          ? `${innerText.replace(/\s/g, '').toLowerCase()}`
          : shortid.generate()
      }`
    );
  },
  getChannel: deviceDetails => {
    if (!deviceDetails.mobile) return APPLICATION_CHANNELS.desktop;
    return APPLICATION_CHANNELS.mobile;
  },
  getGoogleSheetsLink: attributes => {
    if (!attributes) return null;
    try {
      const parsedAttributes = JSON.parse(attributes);
      let sheetsUrl = parsedAttributes.spreadSheetUrl;
      if (sheetsUrl) {
        try {
          sheetsUrl = new URL(sheetsUrl);
          const sheetsSearchParams = sheetsUrl.searchParams;
          sheetsSearchParams.delete('ouid');
          sheetsSearchParams.delete('urlBuilderDomain');
          if (parsedAttributes.cell)
            sheetsSearchParams.append('range', parsedAttributes.cell);
          sheetsUrl.search = sheetsSearchParams.toString();
          const urlString = sheetsUrl.toString();
          return parsedAttributes.sheetId !== undefined &&
            urlString.split('edit').length > 0
            ? urlString
                .split('edit')
                .join(`edit#gid=${parsedAttributes.sheetId}`)
            : urlString;
        } catch (err) {
          return parsedAttributes.spreadSheetUrl;
        }
      }
      return null;
    } catch (err) {
      return null;
    }
  },
  getLinkedGoogleSheetName: attributes => {
    if (!attributes) return null;
    try {
      const parsedAttributes = JSON.parse(attributes);
      return parsedAttributes.spreadSheetName;
    } catch (err) {
      return null;
    }
  },
  getChannelActivityLabel: channel =>
    channel ? IntegrationChannelLabelMap[channel] : null,
  isReactionContainerVisible: containerClass => {
    if (
      document.getElementsByClassName(containerClass).length > 0 &&
      document.querySelector('.ActivityContainer .textBoxContainer')
    ) {
      const mentionTextInputContainerHeight = document.querySelector(
        '.ActivityContainer .textBoxContainer'
      ).scrollHeight;
      const containerBoundRect = document
        .getElementsByClassName(containerClass)[0]
        .getBoundingClientRect();
      const ver_offset = containerBoundRect.y;
      const containerHeight = containerBoundRect.height;
      if (
        ver_offset + containerHeight >
        window.innerHeight - mentionTextInputContainerHeight
      )
        return {
          visible: false,
          verScroll:
            ver_offset +
            containerHeight -
            (window.innerHeight - mentionTextInputContainerHeight)
        };
      return { visible: true };
    }
    return { visible: true };
  },
  removeQueryParamUsingReplace: (queryParamKey, history) => {
    if (!queryParamKey || !history) return;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(queryParamKey);
    history.replace({
      pathname: history.location.pathname,
      search: searchParams.toString()
    });
  },

  setFilterParams: (history, location, filters) => {
    const ORG_SUB_DOMAIN = storage.getDataFromLocal(StorageKey.ORG_INFO)
      ?.sub_domain;

    const searchParams = new URLSearchParams(location.search);
    searchParams.set(QueryParam.FILTERS, JSON.stringify(filters));
    history.push(`/${ORG_SUB_DOMAIN}/objectives?${searchParams.toString()}`);
  },

  areFiltersInURLValid: filters => {
    const keys = Object.keys(filters);
    let isItValid = true;
    for (let i = 0; i < keys?.length; i += 1) {
      const key = keys[i];
      switch (key) {
        case 'objective_type':
          if (!filters[key]) isItValid = false;
          break;
        case 'level':
          if (!(filters[key] >= 0 && filters[key] <= 8)) isItValid = false;
          break;
        case 'status': {
          for (let ind = 0; ind < filters[key].length; ind += 1) {
            const status = filters[key][ind];
            if (!ObjectiveStatusTypes.includes(status)) {
              isItValid = false;
            }
          }
          break;
        }
        case 'objectives_not_updated_from_days':
          if (
            typeof parseInt(filters[key], 10) !== 'number' ||
            parseInt(filters[key], 10) > 150 ||
            parseInt(filters[key], 10) < 0
          ) {
            isItValid = false;
          }
          break;
        case 'due_date': {
          const date = new Date(filters[key]);
          if (!date || date.toString() === 'Invalid Date') isItValid = false;
          break;
        }
        case 'progress_higher_than': {
          if (filters[key] && filters[key] > 200) isItValid = false;
          break;
        }
        case 'progress_lower_than': {
          if (filters[key] && filters[key] < -100) isItValid = false;
          break;
        }
        case 'negotiation_states': {
          for (let ind = 0; ind < filters[key].length; ind += 1) {
            const status = filters[key][ind];
            if (!ObjectiveNegotiationStates.includes(status)) {
              isItValid = false;
            }
          }
          break;
        }
        default:
      }
    }
    return isItValid;
  },

  getFirstMatchingKey: (filtersList, filtersObject) => {
    let key = null;
    Object.keys(filtersObject).forEach(k => {
      const filterKey = filtersList.find(filter => filter === k);
      if (filterKey) {
        key = filterKey;
      }
    });
    if (!key) {
      key = filtersObject.progress_lower_than ? 'progress_lower_than' : null;
    }
    return key;
  },
  appendOrUpdateQueryParam: (queryParamKey, value) => {
    const ORG_SUB_DOMAIN = storage.getDataFromLocal(StorageKey.ORG_INFO)
      ?.sub_domain;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(queryParamKey, value);
    return `/${ORG_SUB_DOMAIN}/objectives?${searchParams.toString()}`;
  },
  removeQueryParam: queryParamKey => {
    const ORG_SUB_DOMAIN = storage.getDataFromLocal(StorageKey.ORG_INFO)
      ?.sub_domain;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(queryParamKey);
    return `/${ORG_SUB_DOMAIN}/objectives?${searchParams.toString()}`;
  },
  convertJsonToString: (json, separator, omitKeys) => {
    if (!json) return json;
    let string = '';
    if (typeof json === 'object')
      Object.keys(json).forEach(key => {
        if (omitKeys.indexOf(key) === -1 && typeof json[key] !== 'object')
          string = string.concat(
            `${string ? `${separator} ` : ''}${key}: ${json[key]}`
          );
      });
    return string;
  },
  convertUTCEpochToLocalTime: epoch =>
    new Date(new Date(0).setUTCSeconds(epoch)),
  scrollIntoView: (ref, parentRef) => {
    try {
      if (!ref) return;
      const ele =
        typeof ref === 'object' ? ref : document.querySelector(`.${ref}`);
      const parent_ele =
        (typeof parentRef === 'object'
          ? parentRef
          : document.querySelector(`.${parentRef}`)) || ele;
      if (ele && parent_ele) {
        const containerBoundRect = ele.getBoundingClientRect();
        const ver_offset = containerBoundRect?.y;
        const containerHeight = containerBoundRect?.height;
        if (
          ver_offset &&
          containerHeight &&
          ver_offset + containerHeight > window.innerHeight
        )
          parent_ele.scrollTo({
            top:
              parent_ele.scrollTop +
              Math.abs(ver_offset + containerHeight - window.innerHeight),
            behavior: 'smooth'
          });
      }
    } catch (err) {
      //
    }
  },

  isEmailRegex: str =>
    isNotEmptyString(str) &&
    str.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ),

  hasAdminRight: role => {
    if (
      role === UserRole.SUPER_ADMIN ||
      role === UserRole.SUPER_HR ||
      role === UserRole.ADMIN
    )
      return true;
    return false;
  },
  isExecutionCycle: cycle_type => cycle_type === ObjectiveCycleTypes.EXECUTION,
  isStrategicCycle: cycle_type => cycle_type === ObjectiveCycleTypes.STRATEGIC,
  isUnboundedCycle: cycle_type => cycle_type === ObjectiveCycleTypes.NON_OKR,
  isValidEpoch: epoch => {
    const date = new Date(+epoch);
    return date instanceof Date && !Number.isNaN(date.getTime());
  },
  isCustomRangeMode: () => {
    const csd = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_START_DATE);
    const ced = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_END_DATE);
    const oc = getValueFromQueryParam(QueryParam.OBJECTIVE_CYCLE);

    const isCsdAndCedValidEpoch =
      appUtils.isValidEpoch(csd) && appUtils.isValidEpoch(ced);

    if (!oc && csd && ced && isCsdAndCedValidEpoch) return true;
    return false;
  },
  isCurrentViewCustomRangeMode: (oc, csd, ced) => {
    const isCsdAndCedValidEpoch =
      appUtils.isValidEpoch(csd) && appUtils.isValidEpoch(ced);

    if (!oc && csd && ced && isCsdAndCedValidEpoch) return true;
    return false;
  },
  getSelectedRangeOKRsCopy: () => 'Objectives',
  getCustomRangeDefaults: () => {
    const currentYear = new Date().getFullYear();
    const orgInfo = storage.getDataFromLocal(StorageKey.ORG_INFO);
    const viewPresetConfig = storage.getDataFromLocal(
      StorageKey.CUSTOM_RANGE_VIEW_PRESET
    );
    try {
      if (
        orgInfo &&
        viewPresetConfig &&
        viewPresetConfig.orgs.some(
          ({ org_reference_id }) =>
            org_reference_id === orgInfo.org_reference_id
        )
      ) {
        const viewPresetConfigForOrg = viewPresetConfig.orgs.find(
          ({ org_reference_id }) =>
            org_reference_id === orgInfo.org_reference_id
        );
        const startMonth = String(viewPresetConfigForOrg.start_month).padStart(
          2,
          '0'
        );
        const endMonth = String(viewPresetConfigForOrg.end_month).padStart(
          2,
          '0'
        );

        const startYear = viewPresetConfigForOrg.start_year
          ? String(viewPresetConfigForOrg.start_year)
          : currentYear;
        const endYear = viewPresetConfigForOrg.end_year
          ? String(viewPresetConfigForOrg.end_year)
          : currentYear;

        const endDateEnd = getLastDayOfTheMonth(+endMonth, endYear);
        const startPeriod = new Date(`${startYear}-${startMonth}-01`);
        const endPeriod = new Date(`${endYear}-${endMonth}-${endDateEnd}`);
        if (
          appUtils.isValidDate(startPeriod) &&
          appUtils.isValidDate(endPeriod)
        )
          return {
            csd: startPeriod.getTime(),
            ced: endPeriod.getTime()
          };
        return {
          csd: new Date(`${currentYear}-01-01`).getTime(),
          ced: new Date(`${currentYear}-12-31`).getTime()
        };
      }
    } catch (_) {
      //
    }
    const previousSelectedCustomRange = appUtils.getCachedConfig(
      ConfigCacheKeys.customRangeRecentSelection,
      StorageKey.PREVIOUS_SELECTED_CUSTOM_RANGE
    );
    if (previousSelectedCustomRange) {
      const prevStartDate = new Date(previousSelectedCustomRange.startDate);
      const prevEndDate = new Date(previousSelectedCustomRange.endDate);
      if (
        appUtils.isValidDate(prevStartDate) &&
        appUtils.isValidDate(prevEndDate)
      ) {
        return {
          csd: prevStartDate.getTime(),
          ced: prevEndDate.getTime()
        };
      }
    }
    return {
      csd: new Date(`${currentYear}-01-01`).getTime(),
      ced: new Date(`${currentYear}-12-31`).getTime()
    };
  },
  epochToStandardDateString: epoch => new Date(+epoch).toISOString().split('T'),
  appendCustomRangeQueryParamsToRequest: requestParams => {
    const csd = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_START_DATE);
    const ced = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_END_DATE);
    if (requestParams && csd && ced) {
      [requestParams.date_range_start] = appUtils.epochToStandardDateString(
        csd
      );
      [requestParams.date_range_end] = appUtils.epochToStandardDateString(ced);
    }
  },

  epochToFormattedDateString: epoch => {
    const dateObj = new Date(+epoch);
    return `${format_date(dateObj, '$MMM$')}'${String(
      dateObj.getFullYear()
    ).substr(-2)}`;
  },
  getSelectedCustomRangeTimePeriod: () => {
    const sd = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_START_DATE);
    const ed = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_END_DATE);
    if (!sd || !ed) return '';
    return `${appUtils.epochToFormattedDateString(
      sd
    )}-${appUtils.epochToFormattedDateString(ed)}`;
  },
  shouldShowManagerApprovalActions: (objective, isManager, objectiveConfig) => {
    /* If setting_is_on && o.status='ACCEPTED' && owner is a direct reportee &&
    manager_approval_status='PENDING' then show approval button */
    const isSettingOn = objectiveConfig?.manager_approval_enabled === true;
    const isObjectiveAccepted = objective?.status === ObjectiveStatus.ACCEPTED;
    const isManagerApprovalPending =
      objective?.manager_approval_details?.manager_approval_status ===
      ManagerApprovalStatus.PENDING;
    return (
      isSettingOn &&
      isObjectiveAccepted &&
      isManager &&
      isManagerApprovalPending
    );
  },
  markNotificationAsRead: (existingNotifications, notificationId) => {
    if (
      existingNotifications.some(
        notification => notification.id === notificationId
      )
    ) {
      const clonedNotifications = [...existingNotifications];
      const notificationIndex = clonedNotifications.findIndex(
        notification => notification.id === notificationId
      );
      clonedNotifications[notificationIndex].read = true;
      return clonedNotifications;
    }
  },
  isValidDate: date => {
    if (!date) return false;
    return date instanceof Date && !Number.isNaN(date.getTime());
  },
  getCachedConfig: (cacheKey, storageKey, isArray = false) => {
    try {
      if (!getCookie(cacheKey).cookieExists) return null;
      const cachedConfig = storage.getDataFromLocal(storageKey);
      if (
        cachedConfig &&
        typeof cachedConfig === 'object' &&
        (!isArray || Array.isArray(cachedConfig))
      )
        return cachedConfig;
      return null;
    } catch (e) {
      return null;
    }
  }
};

export default appUtils;

export const adjustInputHeight = (elementID, resetHeight, defaultHeight) =>
  appUtils.adjustInputHeight(elementID, resetHeight, defaultHeight);

export const getCurrentHomePath = (...queries) => {
  const searchParams = new URLSearchParams(window.location.search);
  for (let i = 0; i < queries.length; i += 1) {
    const query = queries[i];
    if (query.value) searchParams.set(query.key, query.value);
  }
  const queryParam = searchParams.toString();
  const sub_domain = storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain;
  return isNotEmptyString(queryParam)
    ? `/${sub_domain}/objectives?${queryParam}`
    : `/${sub_domain}/objectives`;
};

export const getAbsoluteHomePath = (...queries) => {
  const absolutePathSearchQuery = new URLSearchParams('');
  for (let i = 0; i < queries.length; i += 1) {
    const query = queries[i];
    if (query.value) absolutePathSearchQuery.set(query.key, query.value);
  }
  const queryParam = absolutePathSearchQuery.toString();
  const sub_domain = storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain;
  return isNotEmptyString(queryParam)
    ? `/${sub_domain}/objectives?${queryParam}`
    : `/${sub_domain}/objectives`;
};

export const pushHomeState = (
  homeQueryParam,
  shouldReplace = false,
  historyReactRouter = null
) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (searchParams.toString() === homeQueryParam) return;
  const sub_domain = storage.getDataFromLocal(StorageKey.ORG_INFO)?.sub_domain;
  const homePathWithQuery = isNotEmptyString(homeQueryParam)
    ? `/${sub_domain}/objectives?${homeQueryParam}`
    : `/${sub_domain}/objectives`;
  if (shouldReplace) {
    if (!historyReactRouter) window.location.replace(homePathWithQuery);
    else
      historyReactRouter.replace({
        pathname: `/${sub_domain}/objectives`,
        search: homeQueryParam
      });
  } else if (!historyReactRouter)
    window.history.pushState('', '', homePathWithQuery);
  else
    historyReactRouter.push({
      pathname: `/${sub_domain}/objectives`,
      search: homeQueryParam
    });
};

export const getHomeRedirectPath = () => {
  const redirectPath = storage.getDataFromLocal(StorageKey.REDIRECT_URL);
  storage.removeDataFromLocal(StorageKey.REDIRECT_URL);
  return isNotEmptyString(redirectPath) ? redirectPath : getCurrentHomePath();
};

export const copyToClipboard = (text, callback = null) => {
  const el = document.createElement('textarea');
  el.value = text;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (callback) callback();
};

export const getSelectedTeam = (teams, selectedTeamId) =>
  appUtils.getSelectedTeam(teams, selectedTeamId);

export const isHeaderLeftTabs = tag_id => appUtils.isHeaderLeftTabs(tag_id);

export const removeEmojisFromAString = text =>
  appUtils.removeEmojisFromAString(text);

export const getFullMonth = index => appUtils.getFullMonth(index);

export const parseAlertTextMessage = text =>
  appUtils.parseAlertTextMessage(text);

export const parseLevelsData = (currentUser, levels) =>
  appUtils.parseLevelsData(currentUser, levels);

export const parseFilterCategoriesData = filters =>
  appUtils.parseFilterCategoriesData(filters);

export const generateComponentId = (id, text, component) =>
  appUtils.generateComponentId(id, text, component);

export const getChannel = deviceDetails => appUtils.getChannel(deviceDetails);

export const getGoogleSheetsLink = attributes =>
  appUtils.getGoogleSheetsLink(attributes);

export const getLinkedGoogleSheetName = attributes =>
  appUtils.getLinkedGoogleSheetName(attributes);

export const getChannelActivityLabel = channel =>
  appUtils.getChannelActivityLabel(channel);

export const isReactionContainerVisible = containerClass =>
  appUtils.isReactionContainerVisible(containerClass);

export const removeQueryParamUsingReplace = (queryParamKey, history) =>
  appUtils.removeQueryParamUsingReplace(queryParamKey, history);

export const setFilterParams = (history, location, filters) =>
  appUtils.setFilterParams(history, location, filters);

export const resetFilterParams = (history, location) => {
  const ORG_SUB_DOMAIN = storage.getDataFromLocal(StorageKey.ORG_INFO)
    ?.sub_domain;
  const searchParams = new URLSearchParams(location.search);
  if (searchParams.get('filters')) {
    searchParams.delete('filters');
    history.push(`/${ORG_SUB_DOMAIN}/objectives?${searchParams.toString()}`);
  }
};

export const areFiltersInURLValid = filters =>
  appUtils.areFiltersInURLValid(filters);

export const getFirstMatchingKey = (filtersList, filters) =>
  appUtils.getFirstMatchingKey(filtersList, filters);

export const appendOrUpdateQueryParam = (queryParamKey, value) =>
  appUtils.appendOrUpdateQueryParam(queryParamKey, value);

export const removeQueryParam = queryParamKey =>
  appUtils.removeQueryParam(queryParamKey);

export const convertJsonToString = (
  json = null,
  separator = ',',
  omitKeys = []
) => appUtils.convertJsonToString(json, separator, omitKeys);

export const convertUTCEpochToLocalTime = epoch =>
  appUtils.convertUTCEpochToLocalTime(epoch);

export const scrollIntoView = (ref, parentRef) =>
  appUtils.scrollIntoView(ref, parentRef);

export function debounce(func, timeout = 300, objectiveModuleSpecific = false) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (
        !objectiveModuleSpecific ||
        (window.location.pathname.split('/').length > 2 &&
          window.location.pathname.split('/')[2] === 'objectives')
      )
        func.apply(this, args);
    }, timeout);
  };
}

export function getObjectiveCycleType(start_date, end_date) {
  const d1 = new Date(start_date);
  const d2 = new Date(end_date);
  d1.setHours(0, 0, 0, 0);
  d2.setHours(0, 0, 0, 0);
  return {
    quarterlyCycle: d2.getMonth() - d1.getMonth() === 2,
    halfYearlyCycle: d2.getMonth() - d1.getMonth() === 5,
    executionCycle: [5, 2].indexOf(d2.getMonth() - d1.getMonth()) === -1
  };
}

export const isEmailRegex = str => appUtils.isEmailRegex(str);

export const hasAdminRight = role => appUtils.hasAdminRight(role);

export const isValidDate = date => appUtils.isValidDate(date);

export const getCachedConfig = (cacheKey, storageKey, isArray = false) =>
  appUtils.getCachedConfig(cacheKey, storageKey, isArray);

export const removeObjectProperties = (obj, props) => {
  props.forEach(k => {
    if (Object.prototype.hasOwnProperty.call(obj, k)) {
      delete obj[k];
    }
  });
  return obj;
};

export const isExecutionCycle = cycle_type =>
  appUtils.isExecutionCycle(cycle_type);

export const isStrategicCycle = cycle_type =>
  appUtils.isStrategicCycle(cycle_type);

export const isUnboundedCycle = cycle_type =>
  appUtils.isUnboundedCycle(cycle_type);

export const isCustomRangeMode = () => appUtils.isCustomRangeMode();

export const isCurrentViewCustomRangeMode = (oc, csd, ced) =>
  appUtils.isCurrentViewCustomRangeMode(oc, csd, ced);

export const getSelectedRangeOKRsCopy = () =>
  appUtils.getSelectedRangeOKRsCopy();

export const getCustomRangeDefaults = () => appUtils.getCustomRangeDefaults();

/* 1647946421988 -> 2022-03-22 */
export const epochToStandardDateString = epoch =>
  appUtils.epochToStandardDateString(epoch);

export const appendCustomRangeQueryParamsToRequest = requestParams =>
  appUtils.appendCustomRangeQueryParamsToRequest(requestParams);

export const epochToFormattedDateString = epoch =>
  appUtils.epochToFormattedDateString(epoch);

export const ConditionalWrap = ({ condition, wrap, children }) =>
  condition ? wrap(children) : children;

export const getSelectedCustomRangeTimePeriod = () =>
  appUtils.getSelectedCustomRangeTimePeriod();

export const shouldShowManagerApprovalActions = (
  objective,
  isManager,
  objectiveConfig
) =>
  appUtils.shouldShowManagerApprovalActions(
    objective,
    isManager,
    objectiveConfig
  );

export const hasAdvancedOKRAccess = view =>
  view !== null &&
  [UserViews.ADVANCED_BASIC, UserViews.ADVANCED].indexOf(view) !== -1;

export const hasBasicAccess = view =>
  view !== null &&
  [UserViews.ADVANCED_BASIC, UserViews.BASIC].indexOf(view) !== -1;

export const hasOnlyBasicAccess = view =>
  view !== null && view === UserViews.BASIC;

export const hasOKRModuleAccess = modules =>
  modules?.some(
    module =>
      [UserSubscriptionTypes.ADVANCED, UserSubscriptionTypes.BASIC].indexOf(
        module
      ) > -1
  );

export const hasAllOKRModuleAccess = orgModules =>
  orgModules?.includes(UserSubscriptionTypes.BASIC) &&
  orgModules?.includes(UserSubscriptionTypes.ADVANCED);

export const hasOnlySurveysAccessForUser = accessible_modules =>
  !accessible_modules?.some(module => !['SURVEY', 'AMA'].includes(module));

export const hasSurveyModuleAccess = accessibleModules =>
  accessibleModules?.includes('SURVEY');

export const hasReviewsAccessForUser = accessible_modules =>
  accessible_modules?.some(module => ['REVIEW'].includes(module));

export const shouldShowResendForApprovalButton = (
  objective,
  currentUser,
  objectiveConfig
) => {
  const currentUserId = currentUser?.user_reference_id;
  const isSettingOn = objectiveConfig?.manager_approval_enabled === true;
  const isObjectiveAccepted = objective?.status === ObjectiveStatus.ACCEPTED;
  const isManagerApprovalDenied =
    objective?.manager_approval_details?.manager_approval_status ===
    ManagerApprovalStatus.DENIED;
  return (
    currentUserId ===
      objective?.attributes?.last_manager_approval_status_details
        ?.owner_when_action_taken &&
    currentUserId === objective?.owner_detail?.user_reference_id &&
    isSettingOn &&
    isObjectiveAccepted &&
    isManagerApprovalDenied
  );
};

export const shouldDisableCheckInForAnObjective = (
  objective,
  objectiveConfig,
  featureFlagConfig
) => {
  if (!objective) return true;
  const todaysDate = new Date();
  todaysDate.setHours(0, 0, 0, 0);
  const startDate = new Date(objective.start_date);
  startDate.setHours(0, 0, 0, 0);
  const isManagerApprovalSettingOn =
    objectiveConfig?.manager_approval_enabled === true;
  const isObjectiveApproved =
    [ManagerApprovalStatus.PENDING, ManagerApprovalStatus.DENIED].indexOf(
      objective.manager_approval_details?.manager_approval_status
    ) === -1;
  const shouldDisableCheckinBasedOnPendingApprovalConfig =
    isManagerApprovalSettingOn &&
    !isObjectiveApproved &&
    featureFlagConfig[FirebaseKeys.disable_checkin_on_pending_approval];
  const isStartDateInFuture = startDate.getTime() > todaysDate.getTime();
  return {
    disabled:
      isStartDateInFuture || shouldDisableCheckinBasedOnPendingApprovalConfig,
    reason:
      (isStartDateInFuture &&
        'You cannot create check-ins for future objectives') ||
      (shouldDisableCheckinBasedOnPendingApprovalConfig &&
        'Check-ins are disabled for objectives pending manager approval, request your manager to approve this objective.')
  };
};

export const getShouldAppHeaderBeVisible = () =>
  !!(
    window &&
    window.location &&
    window.location.pathname &&
    !CuesHeaderInvisibilityPaths.some(path =>
      window.location.pathname.includes(path)
    )
  );

export const getLocationStack = () => {
  const currentStack = JSON.parse(
    storage.getDataFromSession(StorageKey.REVIEW_LAST_PAGE)
  );
  if (currentStack) return currentStack;
  storage.saveDataInSession(StorageKey.REVIEW_LAST_PAGE, JSON.stringify([]));
  return [];
};

export const pushToLocationStack = data => {
  const currentStack = getLocationStack();
  if (data.length && currentStack) {
    if (currentStack[currentStack.length - 1] === data) {
      return;
    }
    currentStack.push(data);
    storage.saveDataInSession(
      StorageKey.REVIEW_LAST_PAGE,
      JSON.stringify(currentStack)
    );
  }
};

export const redirectIfOnBoardedToPeopleCues = async localOrgData => {
  try {
    if (
      ['cues', 'localhost'].some(origin =>
        window.location.hostname.startsWith(origin)
      )
    )
      return false;
    const user_orgs = storage.getDataFromLocal(StorageKey.USER_ORGS);
    const urlOrgSubDomain = window.location.pathname.split('/')[1];
    let clearOrgDataBeforeRedirecting = false;
    if (
      user_orgs &&
      user_orgs.length > 1 &&
      localOrgData &&
      urlOrgSubDomain &&
      urlOrgSubDomain !== localOrgData.sub_domain
    )
      clearOrgDataBeforeRedirecting = true;
    const redirectionDetails = await configApi
      .getBlitzRedirectsConfig()
      .then(res => {
        if (!res) return null;
        const {
          data: { data: redirectConfig }
        } = res;
        const isOnboardedToNewApp = true;

        storage.saveDataInLocal(
          StorageKey.IS_PEOPLE_CUES_ORG,
          !!isOnboardedToNewApp && window.location.origin === redirectConfig.to
        );
        if (
          !!isOnboardedToNewApp &&
          window.location.origin === redirectConfig.from
        ) {
          if (clearOrgDataBeforeRedirecting)
            storage.removeDataFromLocal(StorageKey.ORG_INFO);
          return {
            from: redirectConfig.from,
            to: redirectConfig.to
          };
        }
        // props.dispatch(setNewAppRedirectionConfig(redirectConfig));
        return null;
      })
      .catch(err => {
        analytics.trackError('get_blitz_redirects_config', err);
        return null;
      });
    if (redirectionDetails) {
      const newUrl = window.location.href.replace(
        redirectionDetails.from,
        redirectionDetails.to
      );
      window.location.replace(newUrl);
      return true;
    }
    return false;
  } catch (err) {
    analytics.trackError('get_blitz_redirects_config', err);
    return false;
  }
};

export function broadcastMessageToChannel(channelName, eventName) {
  const channel =
    'BroadcastChannel' in window ? new BroadcastChannel(channelName) : null;
  if (channel) {
    channel.postMessage(eventName);
  } else {
    analytics.trackError(
      'BroadcastChannel error',
      'Browser does not have Broadcast channel. Skipping update'
    );
  }
}

export const redirectIfOrgSubDomainNeedsChange = async localOrgData => {
  try {
    const redirectionDetails = await configApi
      .getPeopleCuesSubDomainRedirectsConfig()
      .then(res => {
        if (!res) return null;
        const {
          data: { data: redirectConfigs }
        } = res;
        let { pathname } = window.location;
        pathname = pathname.split('/');
        let isRedirectRequired = false;

        redirectConfigs.forEach(redirectConfig => {
          if (
            redirectConfig?.enabled &&
            redirectConfig?.from === pathname[1] &&
            redirectConfig?.to
          ) {
            pathname[1] = redirectConfig.to;
            pathname = pathname.join('/');
            isRedirectRequired = true;
          }
        });
        if (isRedirectRequired) {
          return { pathname };
        }
        return null;
      })
      .catch(err => {
        analytics.trackError('get_peoplecues_redirect_config', err);
        return null;
      });

    const urlOrgSubDomain = window.location.pathname.split('/')[1];
    const user_orgs = storage.getDataFromLocal(StorageKey.USER_ORGS);
    if (
      user_orgs &&
      user_orgs.length > 1 &&
      localOrgData &&
      urlOrgSubDomain &&
      urlOrgSubDomain !== 'orgs' &&
      urlOrgSubDomain !== localOrgData.sub_domain
    ) {
      const urlOrgDetails = user_orgs.filter(
        org => org.sub_domain === urlOrgSubDomain
      )[0];
      if (urlOrgDetails) {
        storage.saveDataInLocal(StorageKey.ORG_INFO, urlOrgDetails);
        broadcastMessageToChannel(
          'people_cues_session_update',
          'org_details_updated'
        );
        window.location.reload();
        return true;
      }
    }

    if (redirectionDetails) {
      const newUrl = `${window.location.origin}${redirectionDetails.pathname}${window.location.search}`;
      window.location.replace(newUrl);
      return true;
    }
    return false;
  } catch (err) {
    analytics.trackError('get_peoplecues_redirect_config', err);
    return false;
  }
};

export function capitalizeName(name) {
  return (
    name
      ?.split(' ')
      ?.map(val => capitalizeString(val))
      ?.join(' ') || ''
  );
}

export const isWindow = object =>
  (object && object.constructor.name === 'Window') || false;

export const checkIfAwardsCustomer = allSubscriptions => {
  if (allSubscriptions?.subscription_details?.length > 0) {
    return allSubscriptions.subscription_details.some(
      subscription =>
        subscription.type.startsWith('AWARDS_') &&
        subscription.status === 'ACTIVE'
    );
  }
  return false;
};

export const parseStringToJson = jsonString => {
  try {
    const o = JSON.parse(jsonString);

    if (o && typeof o === 'object') {
      return o;
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return null;
};

export function setConfigCache(
  cacheKey,
  storageKey,
  data,
  validFor = 1 /* 1 day */
) {
  if (data) {
    storage.saveDataInLocal(storageKey, data);
    document.cookie = `${cacheKey}=1;path=/;expires=${new Date(
      new Date().getTime() +
        8.64e7 * validFor /* caching the schema for n days */
    ).toGMTString()};secure;samesite=strict`;
  }
}

export const stopOnClickPropagation = event => {
  if (event?.stopPropagation) {
    event.stopPropagation(); // W3C model
  } else if (event?.cancelBubble) {
    event.cancelBubble = true; // IE model
  }
};

export const convertListToMap = (list, key) => {
  const listMap = {};
  if (list && list.constructor === Array && list?.length > 0) {
    Object.values(list).forEach(listItem => {
      const keyValue = listItem[key];
      listMap[keyValue] = listItem;
    });
  }

  return listMap;
};

export const getCustomRangeParameters = () => {
  const rangeDefaults = appUtils.getCustomRangeDefaults();
  const sd =
    getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_START_DATE) ||
    rangeDefaults.csd;
  const ed =
    getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_END_DATE) ||
    rangeDefaults.ced;
  return [sd, ed];
};

export const disableBasicOkrUsersError = ({ objCycle, visibility }) => {
  if (visibility === OBJECTIVE_VISIBILITY_TYPES.publicWithOKR)
    return OwnerAssignmentErrors.publicOkr;
  if (
    objCycle &&
    objCycle.cycle_type &&
    !appUtils.isUnboundedCycle(objCycle.cycle_type)
  )
    return OwnerAssignmentErrors.boundedOkr;
  return null;
};

export const isGoalsAdminVisibilityChecked = visibility =>
  [
    OBJECTIVE_VISIBILITY_TYPES.protectedWithContributorVisibleToAdmin,
    OBJECTIVE_VISIBILITY_TYPES.protectedWithoutContributorVisibleToAdmin
  ].indexOf(visibility) !== -1;

export const isGoalsAdminVisibilityCheckedByDefault = objectiveConfig =>
  objectiveConfig?.admin_visibility_enabled_for_protected_okrs;

export const isProtectedWithContributorsChecked = visibility =>
  [
    OBJECTIVE_VISIBILITY_TYPES.protectedWithContributors,
    OBJECTIVE_VISIBILITY_TYPES.protectedWithContributorVisibleToAdmin
  ].includes(visibility);

export const isProtectedVisibility = objectiveVisibility =>
  [
    OBJECTIVE_VISIBILITY_TYPES.protectedWithoutContributors,
    OBJECTIVE_VISIBILITY_TYPES.protectedWithContributors,
    OBJECTIVE_VISIBILITY_TYPES.protectedWithContributorVisibleToAdmin,
    OBJECTIVE_VISIBILITY_TYPES.protectedWithoutContributorVisibleToAdmin
  ].indexOf(objectiveVisibility) !== -1;

export const isProtectedWithoutAdminVisibility = objectiveVisibility =>
  [
    OBJECTIVE_VISIBILITY_TYPES.protectedWithoutContributors,
    OBJECTIVE_VISIBILITY_TYPES.protectedWithContributors
  ].indexOf(objectiveVisibility) !== -1;

export const getProgressLabel = progress => {
  if (progress < -100) return '< -100';
  if (progress > 1000) return '> 1000';
  return progress;
};

export const handleViewInAlignmentOutsideModule = ({
  dispatch,
  objective,
  objectiveCycles,
  history,
  saveSelectedObjectiveCycle,
  setViewAlignmentPreviousViewState
}) => {
  const ORG_SUB_DOMAIN = storage.getDataFromLocal(StorageKey.ORG_INFO)
    ?.sub_domain;
  const currentPath = window.location.pathname.split('/')[2];
  dispatch(
    setViewAlignmentPreviousViewState({
      objective,
      pageTitle:
        currentPath === 'dashboard'
          ? 'Go back to homepage'
          : currentPath === 'userboard'
          ? 'Go back to userboard'
          : '',
      previousLocation: {
        pathname: history.location.pathname,
        search: history.location.search
      }
    })
  );
  const selectedCycle = objectiveCycles.find(
    ({ id }) => id === objective.objective_cycle.id
  );
  const isNonOkrCycle = appUtils.isUnboundedCycle(
    objective.objective_cycle.cycle_type
  );
  if (!isNonOkrCycle) {
    dispatch(saveSelectedObjectiveCycle(selectedCycle));
    const searchParams = new URLSearchParams();
    searchParams.append('tm', HeaderLeftTabs[2].tag_id);
    searchParams.append('oc', objective.objective_cycle.id);
    history.push({
      pathname: `/${ORG_SUB_DOMAIN}/objectives`,
      search: searchParams.toString()
    });
  } else {
    const searchParams = new URLSearchParams();
    searchParams.append('tm', HeaderLeftTabs[2].tag_id);
    searchParams.append('csd', new Date(objective.start_date).getTime());
    searchParams.append('ced', new Date(objective.due_date).getTime());
    history.push({
      pathname: `/${ORG_SUB_DOMAIN}/objectives`,
      search: searchParams.toString()
    });
  }
};

export function objectEquals(x, y) {
  if (x === y) return true;

  if (!(x instanceof Object) || !(y instanceof Object)) return false;

  if (x.constructor !== y.constructor) return false;

  for (const p in x) {
    if (!x.hasOwnProperty(p)) continue;

    if (!y.hasOwnProperty(p)) return false;

    if (x[p] === y[p]) continue;

    if (typeof x[p] !== 'object') return false;

    if (!objectEquals(x[p], y[p])) return false;
  }

  for (const p in y)
    if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;

  return true;
}

export const validateFilterObject = () => {
  const filters = getValueFromQueryParam(QueryParam.FILTERS);
  let filtersObject = null;
  try {
    filtersObject = JSON.parse(filters);
  } catch (_) {
    //
  }
  return filtersObject;
};

export const titleCase = str => {
  if (!str) return '';
  const splitStr = str
    .trim()
    .toLowerCase()
    .replace(/([\s]+)/g, ' ')
    .split(' ');
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(' ');
};

export const convertTimeToStringWithoutPrefix = time =>
  convertTimeToString(time, DateConversionType.HOUR_AND_DATE).replace(
    /on\s|at\s|st(?!e)|nd|rd(?!a)|th/g,
    ''
  );

export const createTreeHierarchyForActivitiesAndComments = allActivities => {
  const activityTreeMap = {};
  // each enty in this map will be a separate row
  for (const activity of allActivities) {
    if (activity.task_model) {
      // if the activity is a task create a new row
      activityTreeMap[activity.comment_id] = { ...activity, replies: [] };
    } else if (activity.activity_id) {
      // if the activity is not a comment add it as a new row
      activityTreeMap[activity.activity_id] = { ...activity, replies: [] };
    } else if (activity.parent_model) {
      // if the activity is a comment and has a parent model check
      if (
        activity.parent_model.comment_id &&
        activityTreeMap[activity.parent_model.comment_id]
      ) {
        // if the parent is comment add it to the replies of that comment
        activityTreeMap[activity.parent_model.comment_id].replies = [
          ...activityTreeMap[activity.parent_model.comment_id].replies,
          activity
        ];
      } else if (
        activity.parent_model.activity_id &&
        activityTreeMap[activity.parent_model.activity_id]
      ) {
        // if the parent was an activity add it to the respective activities replies
        activityTreeMap[activity.parent_model.activity_id].replies = [
          ...activityTreeMap[activity.parent_model.activity_id].replies,
          activity
        ];
      } else {
        // if the parent models id is not yet in the map then it has already been added as a repply
        // save the parent as a separate thread and add the activity as a reply
        activityTreeMap[activity.parent_model.comment_id] =
          activity.parent_model;
        activityTreeMap[activity.parent_model.comment_id].replies = [activity];
      }
    } else {
      activityTreeMap[activity.comment_id] = { ...activity, replies: [] };
    }
  }
  return Object.values(activityTreeMap);
};

// move this to external app.utils
export const getAllValuesForAKeyFromQueryParam = key =>
  new URLSearchParams(window.location.search).getAll(key);

export const checkIfKeyIsArrayAndSetInUrlParams = (
  searchParams,
  key,
  value
) => {
  if (Array.isArray(value)) {
    const existingValuesForKey = searchParams.getAll(key);
    if (existingValuesForKey.length) searchParams.delete(key);
    value.forEach(val => {
      searchParams.append(key, val);
    });
  } else {
    searchParams.set(key, value);
  }
};

export const formatUserBoardCardsData = data => {
  const parameterisedData = {
    pendingObjectiveCreation: { userCount: 0, users: [] },
    pendingOwnerAcceptance: {
      userCount: 0,
      objectivesCount: 0,
      users: []
    },
    pendingManagerApproval: {
      userCount: 0,
      objectivesCount: 0,
      users: []
    },
    notCheckedin: {
      userCount: 0,
      objectivesCount: 0,
      users: []
    }
  };
  data.forEach(userData => {
    if (
      userData.manager_approval_status_count_map &&
      userData.manager_approval_status_count_map.PENDING
    ) {
      let {
        userCount,
        objectivesCount
      } = parameterisedData.pendingManagerApproval;
      const { users } = parameterisedData.pendingManagerApproval;
      userCount += 1;
      objectivesCount += userData.manager_approval_status_count_map.PENDING;
      users.push(userData);
      parameterisedData.pendingManagerApproval = {
        userCount,
        objectivesCount,
        users
      };
    }
    if (userData.okrs_awaiting_updates) {
      let { userCount, objectivesCount } = parameterisedData.notCheckedin;
      const { users } = parameterisedData.notCheckedin;
      userCount += 1;
      objectivesCount += userData.okrs_awaiting_updates;
      users.push(userData);

      parameterisedData.notCheckedin = { userCount, objectivesCount, users };
    }
    if (userData.okrs_in_negotiation) {
      let {
        userCount,
        objectivesCount
      } = parameterisedData.pendingOwnerAcceptance;
      const { users } = parameterisedData.pendingOwnerAcceptance;

      userCount += 1;
      objectivesCount += userData.okrs_in_negotiation;
      users.push(userData);

      parameterisedData.pendingOwnerAcceptance = {
        userCount,
        objectivesCount,
        users
      };
    }
    if (!userData.okrs_owned || userData.okrs_owned === 0) {
      parameterisedData.pendingObjectiveCreation.userCount += 1;
      parameterisedData.pendingObjectiveCreation.users.push(userData);
    }
  });
  return parameterisedData;
};

export const getUniqueDepartmentsFromUsers = allUsers => {
  const departmentsArray = [];
  allUsers.forEach(user => {
    if (
      user?.user_attributes?.department &&
      !departmentsArray.includes(user.user_attributes.department)
    )
      departmentsArray.push(user.user_attributes.department);
  });
  return departmentsArray;
};

export const checkIfDateStringIsAValidDate = (
  dateString,
  dateFormat = 'yyyy-MM-dd'
) => {
  const parsedDate = parse(dateString, dateFormat, new Date());
  const isValidDateBool = isValid(parsedDate);
  return isValidDateBool;
};

export const parseDateToTimeStamp = date => date.replace(/ /g, 'T');

export const shouldExportBeAvailableForNonAdminUser = (
  role,
  featureFlagConfig
) =>
  !(
    featureFlagConfig[FirebaseKeys.disable_non_admin_access_of_exports] &&
    role === UserRole.USER
  );

export const getCustomReportLink = buttonPath => {
  const ORG_SUB_DOMAIN = storage.getDataFromLocal(StorageKey.ORG_INFO)
    ?.sub_domain;
  if (isCustomRangeMode()) {
    const csd = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_START_DATE);
    const ced = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_END_DATE);
    return `/${ORG_SUB_DOMAIN}/okr-reports?vi=${buttonPath}&csd=${csd}&ced=${ced}`;
  }
  const oc = getValueFromQueryParam(QueryParam.OBJECTIVE_CYCLE);
  if (oc) return `/${ORG_SUB_DOMAIN}/okr-reports?vi=${buttonPath}&oc=${oc}`;
  return `/${ORG_SUB_DOMAIN}/okr-reports?vi=${buttonPath}`;
};

export const getUserboardLink = () => {
  const ORG_SUB_DOMAIN = storage.getDataFromLocal(StorageKey.ORG_INFO)
    ?.sub_domain;
  if (isCustomRangeMode()) {
    const csd = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_START_DATE);
    const ced = getValueFromQueryParam(QueryParam.CUSTOM_DATE_RANGE_END_DATE);
    return `/${ORG_SUB_DOMAIN}/userboard?csd=${csd}&ced=${ced}`;
  }
  return `/${ORG_SUB_DOMAIN}/userboard`;
};

export const createUrlForSignUp = (urlProps, addSubdomain) => {
  const subDomainPath =
    addSubdomain && urlProps.match.params.org
      ? `/${urlProps.match.params.org}`
      : '';
  const { email } = urlProps.match.params;
  const urlSearchParams = new URLSearchParams(urlProps?.location?.search);
  const redirectUrl =
    urlSearchParams.get('redirect_url') || `${origin}${subDomainPath}`;
  const encodedRedirectUrl = encodeURIComponent(redirectUrl);
  const loginUrl =
    `${config.loginUrl}${subDomainPath}/sign-up-invite/${email}` +
    `?email=${email}&redirect_url=${encodedRedirectUrl}&app=PeopleCues`;

  return loginUrl;
};

export const isMetricMandatoryForOrg = featureFlagConfig => {
  if (!featureFlagConfig) return false;
  return featureFlagConfig[FirebaseKeys.metric_mandatory];
};

export const isEmptyObject = obj => {
  if (!obj) return true;
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};
